export default {
  // thresholds
  thresholds: {
    xs: 768,
    sm: 992,
    md: 1250,
  },
  // get client width
  width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
  // conditionals
  mobile: false,
  tablet: false,
  desktop: false,
  update() {
    // set client width
    this.width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    // breakpoints
    const xs = this.width < this.thresholds.xs;
    const sm = this.width < this.thresholds.sm && !xs;
    const md = this.width < this.thresholds.md && !(sm || xs);
    const lg = this.width >= this.thresholds.md;

    // set conditionals
    this.mobile = xs;
    this.tablet = sm;
    this.desktop = md || lg;
  },
};
